export const getClinicsItems = (state) => state.clinics.clinics
export const getIsLoadingClinics = (state) => state.clinics.isLoading
export const getClinicssPagination = (state) => state.clinics.pagination